import React, { useState } from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { useSelector, useDispatch } from 'react-redux';
import { SELECTORS } from '@oneaudi/stck-store';
import { useServicesContext, useSvd, loadFilteredResults } from '@oneaudi/vtp-shared';
import { AudiStockcarsStoreServiceV1 } from '@oneaudi/stockcars-store-service';
import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import { trackLoadMoreVehicles } from '../../tracking/tilesTracking';
import { getAppContext } from '../../hooks/tileHook';
import { Container } from './LoadMoreButton.styles';
import { ProgressIndicator, TextButton } from '@oneaudi/unified-web-components';

const LoadMoreButton: React.FC<{ onLoadMore: () => void }> = ({ onLoadMore }) => {
  const [loading, setLoading] = useState(false);
  const loadMoreBtnLabel = useI18n({ id: 'nemo.ui.sc.load-more-cars.btn' });

  const storeService = useServicesContext().getAdditionalService(
    'audi-stockcars-store-service'
  ) as AudiStockcarsStoreServiceV1;

  const { getConfiguration, getEnvironmentConfig } = useServicesContext();
  const svd = useSvd();

  const dispatch = useDispatch();
  const { vehiclesTotalCount, vehiclesFetched } = useSelector((state: any) => {
    return {
      vehiclesTotalCount: SELECTORS.VEHICLES.getTotalCountState(state),
      vehiclesFetched: SELECTORS.VEHICLES.getResultVehicleIdsState(state),
    };
  });
  const appContext = getAppContext();
  const trackingService = useServicesContext().getAdditionalService(
    'audi-tracking-service'
  ) as TrackingServiceV2;

  if (!vehiclesTotalCount || !vehiclesFetched || vehiclesTotalCount <= vehiclesFetched.length) {
    return null;
  }
  const vehicleLoadIncrement = 12;
  const loadMore = async () => {
    const vehiclesRenderedOnUI =
      vehiclesTotalCount - vehiclesFetched.length > vehicleLoadIncrement
        ? vehiclesFetched.length + vehicleLoadIncrement
        : vehiclesTotalCount;

    setLoading(true);
    await loadFilteredResults(
      { vtpConfiguration: getConfiguration()! },
      getEnvironmentConfig()!,
      storeService.store,
      dispatch,
      appContext,
      svd.svd
    );
    setLoading(false);
    onLoadMore();
    trackLoadMoreVehicles(trackingService, loadMoreBtnLabel, vehiclesRenderedOnUI);
  };

  return (
    <Container>
      <TextButton
        variant="secondary"
        margin={[0, 0, '56px', 0]}
        onClick={loadMore}
        isFullWidth={false}
        data-testid="loadMore"
      >
        {loadMoreBtnLabel}
      </TextButton>
      {loading && <ProgressIndicator variant="bar" type="infinite" colorScheme="colored" />}
    </Container>
  );
};

export default LoadMoreButton;
